import { StreemAPI } from '@streem/api';
import { useState, useCallback } from 'react';
// NOTE: Once ST-2681 is complete we will be able to grab the url from whichever share token endpoint is used and not need
// the helper link functions at the bottom of this file
async function getRoomShareToken(roomSid) {
    const resp = await StreemAPI.rooms.listRoomShareTokens(roomSid);
    if (resp.shareTokens && resp.shareTokens.length > 0) {
        return resp.shareTokens[0].sid;
    }
    else
        return undefined;
}
async function createShareToken(roomSid) {
    const resp = await StreemAPI.rooms.createRoomShareToken(roomSid);
    return resp.shareToken?.sid || '';
}
export const useShareLink = ({ roomSid, anonymousShareEnabled, token, artifactSid, }) => {
    const [link, setLink] = useState(null);
    const refreshLink = useCallback(() => {
        const isAnonymousPage = Boolean(token);
        async function setAnonymousShareLinkWithToken(roomSid, artifactSid) {
            try {
                const token = (await getRoomShareToken(roomSid)) || (await createShareToken(roomSid));
                setLink(anonymousShareLinkUrl(roomSid, artifactSid, token));
            }
            catch (err) {
                setLink('error!');
            }
        }
        // If viewing anonymous call details, use all values from the route
        if (isAnonymousPage) {
            setLink(anonymousShareLinkUrl(roomSid, artifactSid, token));
        }
        else {
            // If viewing auth'd call details, determine if we need to generate a share token.
            // 1. Check company setting: Are we generating anonymous urls? If no, we're done.
            // 2. If we are, check for existence of previously generated tokens and re-use, if present.
            // 3. If not present, create the token and use it.
            if (anonymousShareEnabled) {
                setAnonymousShareLinkWithToken(roomSid, artifactSid);
            }
            else {
                setLink(authenticatedShareLinkUrl(roomSid, artifactSid));
            }
        }
    }, [roomSid, artifactSid, token, anonymousShareEnabled]);
    return [link, refreshLink];
};
export const anonymousShareLinkUrl = (roomId, artifactId, token) => {
    const path = detailPath(roomId, artifactId);
    return token ? `${window.location.origin}/share/${token}/${path}` : '';
};
export const authenticatedShareLinkUrl = (roomId, artifactId) => {
    const path = detailPath(roomId, artifactId);
    return `${window.location.origin}/share/${path}`;
};
const detailPath = (roomId, artifactId) => {
    if (!roomId) {
        return '';
    }
    const parts = ['details', roomId];
    if (artifactId) {
        parts.push('artifact', artifactId);
    }
    return parts.join('/');
};
//# sourceMappingURL=use_share_link.js.map